import { useTranslate } from 'ra-core';
import { authProvider } from '@/authProvider.ts';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useMutation } from '@tanstack/react-query';
import { Button } from '@/components/ui/button.tsx';
import { cn } from '@/lib/utils.ts';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card.tsx';
import { Link } from 'react-router-dom';

export const ForgotPasswordConfirm = ({ email }: { email: string }) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const t = useTranslate();
  const { mutate: sendLink, isPending } = useMutation({
    mutationFn: authProvider.sendPasswordResetLink,
  });

  const handleResendEmail = async () => {
    try {
      const recaptchaAction = 'forgot_password';

      const token = await executeRecaptcha?.(recaptchaAction);
      if (!token) {
        // Do nothing
        return;
      }

      sendLink({
        email,
        token,
        action: recaptchaAction,
      });
    } catch (error: any) {
      // Do nothing to not expose information
    }
  };

  return (
    <>
      <div className={cn('flex flex-col gap-6')}>
        <div>
          <Link to="/">
            <img
              alt="logo"
              src="https://storage.googleapis.com/public-goloot-production/goloot/goloot-logo-white.png"
              style={{ height: 55, width: 'auto', margin: 'auto' }}
            />
          </Link>
        </div>
        <Card>
          <CardHeader>
            <CardTitle>
              {t('auth.message.reset_password.reset_password_sent')}
            </CardTitle>
            <CardDescription>
              {`Check your email at ${email} and click on on the link to reset your password.`}
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
      <div className="flex flex-col gap-2 text-center">
        <div>
          <div className="text-sm mb-2">
            {t('auth.message.email_not_received.line1')}
          </div>
          <div className="text-sm">
            {t('auth.message.email_not_received.check_spam')}{' '}
            <Button onClick={handleResendEmail} disabled={isPending}>
              {t('auth.message.reset_password.resend_email')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
